import { Component } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { BaseComponent, Message} from 'iui-iconectiv-lib';
import { ServiceAgreementService } from './service-agreement.service';


@Component({
  selector: 'app-service-agreement',
  templateUrl: './service-agreement.component.html',
  styleUrls: ['./service-agreement.component.scss']
})
export class ServiceAgreementComponent extends BaseComponent {

  // display service agreement
  showServiceAgreement = false;

  // service aggrement
  serviceAgreementHeader = '';
  serviceAgreementBodyContent = '';

  constructor(
    private serviceAgreementService: ServiceAgreementService,
    private router: Router) {

    super();

    // retrieve service agreement
    this.serviceAgreementService.getServiceAgreement().subscribe(
      res => {
        this.log.debug(`getServiceAgreement(): result message=${JSON.stringify(res['messages'])}`);
        if (res['status'] === 'fail') {
          // failed to reteieve service agreement
          const message: any = res['messages'][0];
          const errorMessage = message['code'] + ' - ' + message['message'];
          this.log.error(`failed to retrieve Service Agreement: ${errorMessage}`);
          this.displayError();
        } else {
          // service agreement retrieved
          const serviceAgreement = res['serviceAgreement'] || null;
          if (serviceAgreement != null) {
            this.serviceAgreementHeader = serviceAgreement['header'];
            this.serviceAgreementBodyContent = serviceAgreement['bodyContent'];

            // display dialog to obtain user acceptance
            this.showServiceAgreement = true;

          } else {
            this.log.error(`retrieved service agreement is empty`);
            this.displayError();
          }
        }
      },
      error => {
        this.log.error(`failed to retrieve service agreement: got HttpError=${JSON.stringify(error)}`);
        this.displayError();
      }
    );

  }

  /**
   * got admin user's acceptance of service agreement, let's save it.
   */
  accept() {
    // post user acceptance
    this.serviceAgreementService.postServiceAgreementAcceptance().subscribe(
      resp => {
        this.log.debug(`data=${JSON.stringify(resp)}`);
        if (resp['status'] === 'fail') {
          // prepare error message
          const message: any = resp['messages'][0];
          const errorMessage = message['code'] + ' - ' + message['message'];
          this.log.error(`getAcceptance(): errorMessage=${errorMessage}`);
          this.displayError();
        } else {
          // finalize account completion
          this.router.navigate(['/account-completion']);
        }
      },
      error => {
        this.log.error(`getAcceptance(): got HttpError=${JSON.stringify(error)}`);
        this.displayError();
      }
    );
  }

  /**
   * log user out
   */
  logmeout() {
    const extras: NavigationExtras = {
      queryParams: { 'dologout': true },
      queryParamsHandling: ''
    };
    this.router.navigate(['/sec/login'], extras);
  }


  /**
   * call base class's displayErrorMessage() for error.
   */
  displayError() {
    this.displayErrorMessage(
      new Message('Error', 'The system was unsuccessful in processing your request. Please try again, or contact Customer Support for assistance.')
    );
  }

}
